export default function translate(i18n, propriete) {
  if (propriete === 'emplacementCentreCommercial.nbHabitantsAireUrbaine') {
    return i18n.t('centreCommercialEmplacement.errorHabitantAirUrbaine');
  }
  if (propriete === 'emplacementCentreCommercial.audienceAn') {
    return i18n.t('centreCommercialEmplacement.errorAudianceAn');
  }
  if (propriete === 'emplacementCentreCommercial.nbContactsAn') {
    return i18n.t('centreCommercialEmplacement.errorNbContactsAn');
  }
  if (propriete === 'emplacementCentreCommercial.audienceHebdo') {
    return i18n.t('centreCommercialEmplacement.errorAudianceHebdo');
  }
  if (propriete === 'emplacementCentreCommercial.nbContactsHebdo') {
    return i18n.t('centreCommercialEmplacement.errorNbContactsHebdo');
  }
  if (propriete === 'emplacementLigneBus.nbBusCirculant') {
    return i18n.t('ligneBusEmplacement.errorNbBus');
  }
  if (propriete === 'emplacementParking.nbPlaces') {
    return i18n.t('parkingEmplacement.errorNbPlaces');
  }
  if (propriete === 'emplacementParking.nbNiveaux') {
    return i18n.t('parkingEmplacement.errorNbNiveau');
  }
  if (propriete === 'adresseCadastrale.Ville') {
    return i18n.t('emplacement.adresse');
  }
  if (propriete === 'adresseCadastrale.Latitude') {
    return i18n.t('adresseEmplacement.lat');
  }
  if (propriete === 'adresseCadastrale.Longitude') {
    return i18n.t('adresseEmplacement.long');
  }
  if (propriete === 'formatId') {
    return i18n.t('materiel.format.error.formatId');
  }
  if (propriete === 'typeId') {
    return i18n.t('materiel.typeMateriel');
  }
  if (propriete === 'emplacementTechnique.NumUG') {
    return i18n.t('adresseEmplacement.numUg');
  }
  if (propriete === 'emplacementTechnique.Quartier') {
    return i18n.t('adresseEmplacement.quartier');
  }
  if (propriete === 'emplacementTechnique.GroupeDhabitation') {
    return i18n.t('adresseEmplacement.groupeDhabitation');
  }
  if (propriete === 'iOT') return i18n.t('dispositifPublicitaire.divers.iot');
  if (propriete === 'pDLElectricite') return i18n.t('dispositifPublicitaire.divers.pdlElectricite');
  if (propriete.indexOf('faces') === 0) {
    const libellePropriete = propriete.slice(propriete.indexOf('.') + 1);
    if (libellePropriete === 'Code') {
      return {
        message: 'face.code',
      };
    }
    if (libellePropriete === 'Information') return i18n.t('face.information');
    if (libellePropriete === 'AncienneReference') return i18n.t('face.oldReference');
  }
  if (propriete === 'clientId') {
    return i18n.t('clientEmplacement.client');
  }
  return propriete;
}
